import React from "react";
import Stack from "@mui/material/Stack";
import { colors, statusColor } from "../Styles";

export const getLegendByStatus = status => {
  switch (status) {
    case "confirmed":
      return "Confirmado";
    case "attendance":
      return "Atendimento";
    case "canceled":
      return "Cancelado";
    case "missed":
      return "Faltou";
    case "finished":
      return "Finalizado";
    default:
      return "Agendado";
  }
};

export const ColorLegend = () => (
  <Stack
    direction="row"
    flexWrap="wrap"
    justifyContent="space-between"
    sx={{
      padding: "8px",
      // backgroundColor: "grey.200",
      // borderBottom: "1px solid #ccc",
      fontSize: "12px",
      "div": {
        width: "100px",
        mb: "2px",
      },
      "& span": {
        width: "16px",
        height: "16px",
        borderRadius: "50%",
        display: "inline-block",
        verticalAlign: "top",
        mr: 1,
        "&.brown": {
          backgroundColor: colors.brown.light,
          border: `1px solid ${colors.brown.dark}`,
        },
        "&.cyan": {
          backgroundColor: colors.cyan.light,
          border: `1px solid ${colors.cyan.dark}`,
        },
        "&.green": {
          backgroundColor: colors.green.light,
          border: `1px solid ${colors.green.dark}`,
        },
        "&.indigo": {
          backgroundColor: colors.indigo.light,
          border: `1px solid ${colors.indigo.dark}`,
        },
        "&.purple": {
          backgroundColor: colors.purple.light,
          border: `1px solid ${colors.purple.dark}`,
        },
        "&.red": {
          backgroundColor: colors.red.light,
          border: `1px solid ${colors.red.dark}`,
        },
        "&.yellow": {
          backgroundColor: colors.yellow.light,
          border: `1px solid ${colors.yellow.dark}`,
        },
      }
    }}
  >
    {Object.keys(statusColor).map(status => (
      <div key={status}>
        <span className={statusColor[status]} />
        {getLegendByStatus(status)}
      </div>
    ))}
  </Stack>
)
